// Congela width/height en px de imágenes y nodos clave para dom-to-image.
// Devuelve una función restore() que revierte los cambios.
export function freezeComputedSizes(root) {
    const changed = [];

    // 1) Congelar <img> (logo, firma)
    root.querySelectorAll('img').forEach(img => {
        const r = img.getBoundingClientRect();
        changed.push([img, {
            width: img.style.width,
            height: img.style.height,
            maxWidth: img.style.maxWidth,
            maxHeight: img.style.maxHeight,
            objectFit: img.style.objectFit,
            display: img.style.display,
        }]);
        img.style.display = 'block';               // evita inline-gap raros
        img.style.objectFit = 'contain';           // por seguridad
        img.style.width = `${Math.round(r.width)}px`;
        img.style.height = `${Math.round(r.height)}px`;
        img.style.maxWidth = `${Math.round(r.width)}px`;
        img.style.maxHeight = `${Math.round(r.height)}px`;
    });

    // 2) Congelar el contenedor raíz (alto/ancho exactos)
    const r = root.getBoundingClientRect();
    changed.push([root, {
        width: root.style.width,
        height: root.style.height,
    }]);
    root.style.width = `${Math.round(r.width)}px`;
    root.style.height = `${Math.round(r.height)}px`;

    // 3) Simplificar flex/gap durante la captura (clase temporal)
    root.classList.add('signature-capture-clean');

    return function restore() {
        // Restaurar estilos
        for (const [el, prev] of changed) Object.assign(el.style, prev);
        root.classList.remove('signature-capture-clean');
    };
}

// DPR helper
export const getDPR = () => Math.max(1, window.devicePixelRatio || 1);

export const isSafari = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    return /Version\/[\d.]+.*Safari/.test(ua) && !/Chrome|CriOS|OPR|Edg\//.test(ua);
};

export async function waitImagesReady(root, timeoutMs = 1200) {
    const imgs = Array.from(root?.querySelectorAll('img') || []);
    await Promise.all(imgs.map(img => new Promise(resolve => {
        if (img.complete && img.naturalWidth > 0) return resolve();
        let done = false;
        const cleanup = () => {
            if (done) return;
            done = true;
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
            resolve();
        };
        const onLoad = () => cleanup();
        const onError = () => cleanup();
        img.addEventListener('load', onLoad, { once: true });
        img.addEventListener('error', onError, { once: true });
        setTimeout(cleanup, timeoutMs);
    })));
}
